import { Component, input, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  public type = input<
    | undefined
    | 'success'
    | 'info'
    | 'warning'
    | 'danger'
    | 'primary'
    | 'secondary'
  >();
  protected closed = signal(false);
  public close = output();
  closeClicked() {
    this.closed.set(true);
    this.close.emit();
  }
}
